var map = {
	"./badesee-petershagen/assets/favicon/badesee-petershagen.webp": [
		12322,
		2322
	],
	"./demo/assets/favicon/demo.webp": [
		25634,
		5634
	],
	"./dhu/assets/favicon/dhu.webp": [
		81968,
		1968
	],
	"./kolula-key/assets/favicon/demo.webp": [
		9973,
		9973
	],
	"./kolula-key/assets/favicon/kolula-key.webp": [
		14582,
		4582
	],
	"./kolula/assets/favicon/kolula.webp": [
		79590
	],
	"./neuland/assets/favicon/neuland.webp": [
		37764,
		7764
	],
	"./seezeit/assets/favicon/seezeit.webp": [
		48340,
		8340
	],
	"./segmenta/assets/favicon/vonovia.webp": [
		55894,
		5894
	],
	"./strandbad-pertisau/assets/favicon/strandbad-pertisau.webp": [
		73934,
		3934
	],
	"./vonovia/assets/favicon/vonovia.webp": [
		42678,
		2678
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 54252;
module.exports = webpackAsyncContext;